<template>
  <div class="animated fadeIn list-of-ap">
    <b-card>
      <div slot="header">
        List of AP Contract / UnBilled
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="deleteConfirm"
            >Delete</b-button
          >
          <b-dropdown text="Posting" variant="primary mr-1">
            <b-dropdown-item
              @click="posting"
              :disabled="model.posting == 1 || selected.length > 0"
              >Posting 1</b-dropdown-item
            >
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item
              @click="posting"
              :disabled="model.posting != 1 || selected.length > 0"
              >Un Posting 1</b-dropdown-item
            >
          </b-dropdown>
          <b-button variant="primary mr-1" @click="printjv">Print</b-button>
          <b-button variant="primary mr-1" @click="payment()"
            >Bill Hist.</b-button
          >
          <b-button variant="primary mr-1" @click="exportxls()"
            ><i class="fa fa-file-excel-o"></i>Export</b-button
          >
          <b-button variant="primary mr-1" @click="togleFilter()"
            ><i class="fa fa-filter"></i> Filter</b-button
          >
          <b-button variant="primary mr-1" @click="close()">
            <i class="fa fa-close"></i> Close</b-button
          >
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col md="6">
          <b-row>
            <b-col lg="9">
              <b-input-group>
                <b-input-group-prepend
                  ><label>UnBill No.</label></b-input-group-prepend
                >
                <b-form-input
                  v-model="tblData.nomor"
                  placeholder=" % for wildcard"
                ></b-form-input>
                <b-input-group-prepend
                  ><span class="pt-2"
                    >Contract# &nbsp;</span
                  ></b-input-group-prepend
                >
                <b-form-input
                  v-model="tblData.po"
                  placeholder="Contract No."
                  style="width: 27% !important"
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="3">
              <b-input-group>
                <b-input-group-prepend
                  ><span class="pt-2"
                    >Outstanding &nbsp;</span
                  ></b-input-group-prepend
                >
                <b-form-select
                  v-model="tblData.outstand"
                  :plain="true"
                  :options="dataList.YesNoAll"
                ></b-form-select>
              </b-input-group>
            </b-col>
          </b-row>
          <!-- <b-input-group >
                <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
                <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
                <b-input-group-prepend><span class="input-group-text">value</span></b-input-group-prepend>
                <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input>
              </b-input-group> -->
          <b-input-group>
            <b-input-group-prepend
              ><label>Vendor/Supplier</label></b-input-group-prepend
            >
            <b-form-input
              v-model="tblData.vendor"
              placeholder="Vendor/Supplier"
            ></b-form-input>
            <b-form-input
              v-model="tblData.uraian"
              placeholder="Description"
              class="ml-1"
            ></b-form-input>
          </b-input-group>
          <!-- <b-input-group>
            <b-input-group-prepend
              ><label>Contract No.</label></b-input-group-prepend
            >
            <b-form-input
              v-model="tblData.po"
              placeholder="Contract/SKA No."
              style="width: 27% !important"
            ></b-form-input>
          </b-input-group> -->
        </b-col>
        <b-col md="6">
          <b-row>
            <b-col lg="9">
              <b-input-group>
                <b-input-group-prepend
                  ><label>Post Date</label></b-input-group-prepend
                >
                <b-form-input v-model="tblData.tgl1" type="date"></b-form-input>
                <b-input-group-prepend
                  ><span class="input-group-text"
                    >until</span
                  ></b-input-group-prepend
                >
                <b-form-input v-model="tblData.tgl2" type="date"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="3">
              <b-input-group>
                <b-input-group-prepend
                  ><span class="pt-2"
                    >Posting &nbsp;</span
                  ></b-input-group-prepend
                >
                <b-form-select
                  v-model="tblData.posting"
                  :plain="true"
                  :options="dataList.postingStatus"
                ></b-form-select>
              </b-input-group>
            </b-col>
          </b-row>

          <b-input-group>
            <b-input-group-prepend
              ><label>AP Posting Group</label></b-input-group-prepend
            >
            <b-form-select
              v-model="tblData.postgroup"
              :plain="true"
              :options="postGroups"
              style="width: 25% !important"
            ></b-form-select>
            <b-input-group-prepend
              ><span class="pt-2">Account# &nbsp;</span></b-input-group-prepend
            >
            <b-form-input
              v-model="tblData.kodeacc"
              placeholder="AP Account Code"
            ></b-form-input>
            <b-input-group-append>
              <b-button
                variant="success"
                size="sm"
                @click="search()"
                class="ml-3"
              >
                <i class="fa fa-refresh"></i> Apply Filter</b-button
              >
            </b-input-group-append>
            <b-input-group-append>
              <b-button
                variant="secondary"
                size="sm"
                class="ml-2"
                @click="clearFilter()"
                >Clear Filter</b-button
              >
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>

      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        striped
        hover
        style="font-size: smaller"
        :items="tblDataItems"
        :fields="tblFields"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        @row-clicked="rowClicked"
      >
        <template v-slot:cell(action)="data">
          <b-dropdown
            dropright
            variant="outline-secondary"
            toggle-class="text-decoration-none"
            no-caret
            size="sm"
            style="margin: -10px"
          >
            <template v-slot:button-content>
              <i class="fa fa-play text-primary"></i>
            </template>
            <b-dropdown-item
              @click="rowEdit(data.item)"
              href="#"
              :disabled="data.item.posting == 1"
              style="padding: 0 !important"
              >Edit</b-dropdown-item
            >
            <!-- <b-dropdown-item
              @click="rowPost(data.item)"
              href="#"
              :disabled="data.item.posting == 1"
              style="padding: 0 !important"
              >Posting</b-dropdown-item
            >
            <b-dropdown-item
              @click="rowPost(data.item)"
              href="#"
              :disabled="data.item.posting == 0"
              style="padding: 0 !important"
              >Un Posting</b-dropdown-item
            >
            <b-dropdown-item
              @click="rowPrintjv(data.item)"
              href="#"
              :disabled="data.item.posting == 0"
              style="padding: 0 !important"
              >Print JV</b-dropdown-item
            > -->
            <b-dropdown-item
              @click="rowBillHist(data.item)"
              href="#"
              style="padding: 0 !important"
              >Bill Hist</b-dropdown-item
            >
            <b-dropdown-item
              @click="rowDel(data.item)"
              href="#"
              :disabled="data.item.posting == 1"
              style="padding: 0 !important"
            >
              Delete</b-dropdown-item
            >
          </b-dropdown>
        </template>
        <template v-slot:cell(nomor)="data">
          <div v-if="data.item.posting == 0" style="background-color: yellow">
            {{ data.item.nomor }}
          </div>
          <div v-else>{{ data.item.nomor }}</div>
        </template>

        <template v-slot:cell(tanggal)="data">
          {{ data.item.tanggal | moment("DDMMMYYYY") }}
        </template>
        <template v-slot:cell(tgl_awal)="data">
          {{ data.item.tgl_awal | moment("DDMMMYYYY") }}
        </template>
        <template v-slot:cell(tgl_akhir)="data">
          {{ data.item.tgl_akhir | moment("DDMMMYYYY") }}
        </template>
        <template v-slot:cell(totkontrak)="data">
          <div v-if="data.item.posting == 0" style="background-color: yellow">
            {{ data.item.totkontrak | numFormat }}
          </div>
          <div v-else>
            {{ data.item.totkontrak | numFormat }}
          </div>
        </template>
        <template v-slot:cell(ditagih)="data">
          {{ data.item.ditagih | numFormat }}
          <div
            v-if="data.item.ditagih != 0"
            style="font-size: smaller; font-style: italic"
          >
            {{ data.item.nomorap }}
          </div>
        </template>

        <template v-slot:cell(siskontrak)="data">
          {{ data.item.siskontrak | numFormat }}
        </template>
      </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-1">
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }} to
            <span v-if="tblData.page * tblData.limit > tblData.total">{{
              tblData.total
            }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span> of
            {{ tblData.total }} entries
          </div>
        </b-col>
        <b-col cols="5">
          <b-input-group>
            <b-input-group-prepend
              ><span class="pt-1 pr-2"
                >Limit per page</span
              ></b-input-group-prepend
            >
            <b-form-input
              v-model="limit"
              type="number"
              class="mr-2"
              v-b-tooltip.hover
              :title="`${limit} records`"
              style="max-width:80px; !important;"
            ></b-form-input>
            <b-pagination
              v-if="pagination"
              :total-rows="tblData.total"
              :per-page="tblData.limit"
              v-model="tblData.page"
            ></b-pagination>
          </b-input-group>
        </b-col>
        <b-col cols="3">
          <div class="text-right pt-1">
            <span style="background-color: yellow"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
            >
            <span class="mr-2">Record Not Posted</span>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <loading
      :active.sync="isLoading"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
    <b-modal
      v-model="showDelConfirm"
      title="Delete Record?"
      :centered="true"
      @ok="deleteData"
    >
      <p class="mb-1">1 record is about to be permanently deleted</p>
      <p class="font-weight-bold m-0 text-danger">
        Are you sure about doing this?
      </p>
    </b-modal>
    <b-modal
      v-model="showPostingConfirm"
      title="Posting Record?"
      :centered="true"
      @ok="postingData"
    >
      <p class="mb-1">
        The selected a row of data will be Posted to Accounting?
      </p>
      <p class="font-weight-bold m-0 text-danger">
        You can unpost as long as <strong>Accounting Periode</strong> stil open
      </p>
    </b-modal>
    <b-modal
      v-model="showUnpostConfirm"
      title="Un Posting Record?"
      :centered="true"
      @ok="unpostData"
    >
      <p class="mb-1">
        The selected a row of data will be UnPosted from Accounting?
      </p>
      <p class="font-weight-bold m-0 text-danger">
        Data Journal will be removed from <strong>Accounting</strong>
      </p>
    </b-modal>
    <b-modal
      v-model="showReport"
      scrollable
      size="xl"
      title="Preview as PDF"
      hide-footer
    >
      <iframe :src="reportUrl" frameborder="0"></iframe>
      <b-row class="justify-content-center mt-1">
        <b-button
          variant="primary"
          v-if="isprintjv == true"
          @click.stop="editjv"
          >Edit Journal</b-button
        >
        <b-button variant="secondary" class="ml-2" @click="showReport = false">
          Close</b-button
        >
      </b-row>
    </b-modal>
    <b-modal
      v-model="showPaymentForm"
      scrollable
      size="xl"
      title="Billing/Invoice History"
      hide-footer
    >
      <b-form-row>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend
              ><label>UnBill Number</label></b-input-group-prepend
            >
            <b-form-input v-model="paymdata.nomor" readonly></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend
              ><label>Posting Date</label></b-input-group-prepend
            >
            <b-form-input
              v-model="paymdata.tanggal"
              type="date"
              disabled
            ></b-form-input>
          </b-input-group>
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend
              ><label>Contract Number</label></b-input-group-prepend
            >
            <b-form-input
              v-model="paymdata.agreement_no"
              readonly
            ></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend
              ><label>Tgl SKA</label></b-input-group-prepend
            >
            <b-form-input
              v-model="paymdata.tglSKA"
              type="date"
              disabled
            ></b-form-input>
          </b-input-group>
        </b-col>
      </b-form-row>
      <b-input-group>
        <b-input-group-prepend
          ><label>Vendor/Supplier</label></b-input-group-prepend
        >
        <b-form-input readonly v-model="paymdata.vendorinfo"></b-form-input>
      </b-input-group>
      <b-input-group>
        <b-input-group-prepend
          ><label>Description</label></b-input-group-prepend
        >
        <b-form-input
          v-model="paymdata.agreement_title"
          readonly
        ></b-form-input>
      </b-input-group>
      <b-form-row>
        <b-col cols="6">
          <b-input-group>
            <b-input-group-prepend
              ><label>Total Amount</label></b-input-group-prepend
            >
            <b-input-group-prepend
              ><span class="input-group-text" style="width: 60px">{{
                paymdata.matauang
              }}</span></b-input-group-prepend
            >
            <my-number
              class="form-control text-right"
              separator=","
              v-model="paymdata.totkontrak"
              :precision="2"
              readonly
            ></my-number>
          </b-input-group>
        </b-col>
        <!-- <b-col cols="6">   
                      <b-input-group>
                          <b-input-group-prepend><label>Related to other Invoice #</label></b-input-group-prepend>
                          <b-form-input v-model="model.invoicereff" readonly=""></b-form-input>
                      </b-input-group>
                  </b-col> -->
      </b-form-row>
      <b-card no-body class="mb-1">
        <div class="report-wraper">
          <table style="width: 100%">
            <thead>
              <tr>
                <th width="80px">Date</th>
                <th width="110px">Doc. Number</th>
                <th width="110px">Doc. Name</th>
                <th>Description</th>
                <th width="90px">Input By</th>
                <th width="140px" style="text-align: right">Debit</th>
                <th width="140px" style="text-align: right">Credit</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in paymdata.paymLines" :key="row.tablekey">
                <td :class="row.kelas">
                  {{ row.tanggal | moment("DD MMM YYYY") }}
                </td>
                <td :class="row.kelas">{{ row.nomor }}</td>
                <td :class="row.kelas">{{ row.paymethod }}</td>
                <td :class="row.kelas">{{ row.uraian }}</td>
                <td :class="row.kelas">{{ row.createby }}</td>
                <td :class="row.kelas" style="text-align: right">
                  {{ row.nilaibayar | numFormat }}
                </td>
                <td :class="row.kelas" style="text-align: right">
                  {{ row.nilaiap | numFormat }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-card>
      <b-row class="mt-1">
        <b-col lg="4">
          <div class="text-right">
            <b-input-group>
              <b-input-group-prepend
                ><label
                  style="text-align: left; width: 100px; padding-left: 16px"
                  >Invoiced</label
                ></b-input-group-prepend
              >
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 60px">{{
                  paymdata.matauang
                }}</span>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="paymdata.ditagih"
                :precision="2"
                disabled
              ></my-number>
            </b-input-group>
          </div>
        </b-col>
        <b-col lg="4">
          <div class="text-right">
            <b-input-group>
              <b-input-group-prepend
                ><label
                  style="text-align: left; width: 100px; padding-left: 16px"
                  >Settlement</label
                ></b-input-group-prepend
              >
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 60px">{{
                  paymdata.matauang
                }}</span>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="paymdata.dibayar"
                :precision="2"
                disabled
              ></my-number>
            </b-input-group>
          </div>
        </b-col>
        <b-col lg="4">
          <div class="text-right">
            <b-input-group>
              <b-input-group-prepend
                ><label
                  style="text-align: left; width: 158px; padding-left: 16px"
                  >Oustanding</label
                ></b-input-group-prepend
              >
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 60px">{{
                  paymdata.matauang
                }}</span>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="paymdata.siskontrak"
                :precision="2"
                disabled
              ></my-number>
            </b-input-group>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<style lang="scss">
.list-of-ap {
  table {
    td {
      .dropdown-item {
        padding: 0.1rem 1.5rem !important;
        font-size: smaller !important;
      }
    }
  }
}
</style>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import myNumber from "../../components/my-number";
import apkontrak from "../../apis/apkontrak";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
toastr.init();

export default {
  components: { Loading, myNumber },
  data() {
    return {
      showFilter: false,
      showDelConfirm: false,
      showPostingConfirm: false,
      showUnpostConfirm: false,
      showVoidConfirm: false,
      showPaymentForm: false,
      paymdata: { paymLines: [] },
      isLoading: false,
      showReport: false,
      isprintjv: false,
      reportUrl: null,
      pagination: false,
      limit: 15,
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        // tgl1:this.$store.state.user.tglaktif,
        // tgl2:this.$store.state.user.akhirbln,
        sortBy: "tanggal",
        sortDesc: true,
        DimCol: "Dim1",
      },
      tblDataItems: [],
      model: {},
      deleted: {},
      postGroups: [],
      selected: [],
      receivingStatus: [
        { value: "1", text: "Received" },
        { value: "0", text: "Not Received" },
        { value: "", text: "--- ALL ---" },
      ],
      dataList: {
        YesNoAll: dropdown.ostandStatus,
        postingStatus: dropdown.postingStatus,
      },
    };
  },
  computed: {
    dimension() {
      return this.$store.state.dimension;
    },
    tblFields() {
      const fields = [
        {
          key: "action",
          label: "",
          thStyle: "width:40px",
          thClass: "text-center",
        },
        {
          key: "nomor",
          thStyle: "width:100px",
          label: "AP. UnBill #",
          sortable: true,
        },
        {
          key: "tanggal",
          thStyle: "width:90px",
          label: "Tgl. Posting",
          sortable: true,
        },
        {
          key: "vendorinfo",
          label: "Vendor/Supplier",
          thStyle: "width:200px",
          sortable: true,
        },
        {
          key: "angreement_no",
          thStyle: "width:100px",
          label: "No. Kontrak",
          sortable: true,
        },
        {
          key: "agreement_title",
          thStyle: "width:400px",
          label: "Uraian",
        },
        {
          key: "tgl_awal",
          thStyle: "width:90px",
          label: "Awal Kontrak",
          sortable: true,
        },
        {
          key: "tgl_akhir",
          thStyle: "width:90px",
          label: "Akhir Kontrak",
          sortable: true,
        },
        {
          key: "totkontrak",
          label: "Nilai Kontrak",
          thStyle: "width:100px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "ditagih",
          label: "Ditagih",
          thStyle: "width:100px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "siskontrak",
          label: "sisa UnBill",
          thStyle: "width:100px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true,
        },
          {
            key: "ApUnBillCrAcc",
            thStyle: "width:120px",
            label: "AP UnBill Account",
            sortable: true
          },
          {
            key: "ApUnBillDbAcc",
            thStyle: "width:120px",
            label: "Prepaid/Asset Account",
            sortable: true
          },
          {
            key: "UnbillCogsAcc",
            thStyle: "width:120px",
            label: "Amortz.COS Account",
            sortable: true
          },
      ];
      // const dims = this.$store.state.dimension;
      // for (let i = 0; i < dims.length; i += 1) {
      //   fields.push(          {
      //     key: `${dims[i].value}Txt`,
      //     // thStyle: "width:100px",
      //     label: dims[i].text,
      //     sortable: true
      //   },)
      // }
      return fields;
    },
    dimCol() {
      return this.tblData.DimCol;
    },
  },
  watch: {
    dimCol: function (newval) {
      this.tblData.DimVal = "";
      this.tblData.DimValInfo = "";
      this.tblData.DimColInfo = this.dimension.find(
        (d) => d.value === newval
      ).text;
    },
    limit: function (newVal) {
      setTimeout(() => {
        if (this.limit == newVal) {
          this.tblData.limit = newVal;
        }
      }, 500);
    },
    "tblData.page": function (newval) {
      this.data();
    },
    "tblData.limit": function (newval) {
      this.data();
    },
    "tblData.sortBy": function (newval) {
      this.data();
    },
    "tblData.sortDesc": function (newval) {
      this.data();
    },
  },
  created: async function () {
    if (this.$route.params.nomor) {
      this.clearFilter();
      this.tblData.nomor = this.$route.params.nomor;
    }
    setTimeout(async () => {
      const accList = await apkontrak.postgroup();
      this.postGroups = accList.reduce(
        (newArr, item) => {
          newArr.push(item);
          return newArr;
        },
        [{ value: "", text: "--- ALL ---" }]
      );
      // const tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
      // this.tblData.tgl1=this.$store.state.user.tglaktif;
      // this.tblData.tgl2=tgl2.format('YYYY-MM-DD');
    }, 1000);
    this.data();
  },
  sockets: {
    apinvtrx: function (data) {
      console.log("IO: apinvtrx ", data.source);
      const ada = this.tblDataItems.find(
        (a) => a.kontrakKey == data.kontrakKey
      );
      if (ada) {
        for (var key in data) {
          ada[key] = data[key];
        }
      }
    },
    apinvdeleted: function (data) {
      const index = this.tblDataItems.findIndex(
        (a) => a.kontrakKey == data.kontrakKey
      );
      this.tblDataItems.splice(index, 1);
    },
  },

  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function (ctx) {
      const tblOrder = {
        sortBy: this.tblData.sortBy,
        sortDesc: this.tblData.sortDesc,
      };
      this.pagination = false;
      const filter = this.$store.state.filter;
      let filtered = false;
      for (var key in filter.apkontrak) {
        this.tblData[key] = filter.apkontrak[key];
        filtered = true;
      }
      if (filtered === true) {
        if (!filter.apkontrak.tgl1) {
          this.tblData.tgl1 = "";
          this.tblData.tgl2 = "";
        }
        this.showFilter = filtered;
        delete filter.apkontrak;
        this.$store.commit("filter", filter);
        let autoRefresh = true;
        if (this.tblData.page == 1) {
          if (
            tblOrder.sortBy == this.tblData.sortBy &&
            tblOrder.sortDesc == this.tblData.sortDesc
          ) {
            autoRefresh = false;
          } else autoRefresh = true;
        }
        if (autoRefresh == false) {
          this.isLoading = true;
          this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
          try {
            const list = await apkontrak.list(this.tblData);
            this.pagination = true;
            this.tblDataItems = list;
            this.isLoading = false;
            // return list;
          } catch (error) {
            this.isLoading = false;
            if (error.message) {
              toastr.error(error.message, "ERROR MESSAGE", 10000);
            } else {
              toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
            }
          }
        }
      } else {
        this.isLoading = true;
        this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
        try {
          const list = await apkontrak.list(this.tblData);
          this.pagination = true;
          this.tblDataItems = list;
          this.isLoading = false;
          // return list;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },
    refresh(ctx) {
      if (this.$refs.table) {
        // this.$refs.table.refresh();
        this.data();
      }
    },
    search(ctx) {
      this.tblData.page = 1;
      this.data();
    },
    clearFilter(ctx) {
      this.tblData.vendor = "";
      this.tblData.po = "";
      this.tblData.uraian = "";
      this.tblData.nomor = "";
      this.tblData.invoice = "";
      this.tblData.postgroup = "";
      this.tblData.tgl1 = "";
      this.tblData.tgl2 = "";
      this.tblData.DimVal = "";
    },
    togleFilter() {
      this.showFilter = !this.showFilter;
    },
    saveFilter() {
      const keys = [
        "sortBy",
        "sortDesc",
        "uraian",
        "DimCol",
        "DimVal",
        "tgl1",
        "tgl2",
        "outstand",
        "nomor",
        "invoice",
        "vendor",
        "vendorcode",
        "po",
        "postgroup",
        "posting",
      ];
      let filtered = false;
      const apkontrak = {};
      for (const key in this.tblData) {
        if (keys.indexOf(key) >= 0 && this.tblData[key]) {
          filtered = true;
          apkontrak[key] = this.tblData[key];
        }
      }
      if (filtered === true) {
        apkontrak.page = this.tblData.page;
        apkontrak.limit = this.tblData.limit;
        apkontrak.sortBy = this.tblData.sortBy;
        apkontrak.sortDesc = this.tblData.sortDesc;
        const filter = this.$store.state.filter;
        filter.apkontrak = apkontrak;
        this.$store.commit("filter", filter);
      }
    },
    rowEdit(record) {
      this.rowClicked(record);
      this.edit();
    },
    rowPost(record) {
      this.rowClicked(record);
      this.posting();
    },
    rowVoid(record) {
      this.model = record;
      this.voidConfirm();
    },
    rowPrint(record) {
      this.rowClicked(record);
      this.print();
    },
    rowPrintjv(record) {
      this.rowClicked(record);
      this.printjv();
    },
    rowPrintpb(record) {
      this.rowClicked(record);
      this.printpb();
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();
    },
    rowBillHist(record) {
      this.rowClicked(record);
      this.payment();
    },
    add() {
      this.saveFilter();
      router.push({ name: "payable.apkontrakfrm" });
    },
    edit: function () {
      if (this.model.kontrakKey) {
        this.saveFilter();
        router.push({
          name: "payable.apkontrakfrm",
          params: { kontrakKey: this.model.kontrakKey },
        });
      } else {
        toastr.warn("Please select a row that want to be Edit!");
      }
    },
    editjv: function () {
      if (this.model.kontrakKey) {
        this.saveFilter();
        const tanggal = moment(this.model.tanggal).format("YYYY-MM-DD");
        // router.push({name :'payable.editjvfrm', params: { nomor: this.model.nomor, tanggal, kodejurnal:'APINV', fsubkode2:'ap_invoice_tt',kodefield2:'kontrakKey',subkode2: this.model.kontrakKey}});
        router.push({
          name: "payable.editjvfrm",
          params: { nomor: this.model.nomor, tanggal: this.model.tanggal },
        });
      } else {
        toastr.warn("Please select a row that want to be Edit!");
      }
    },
    deleteConfirm() {
      if (this.model.kontrakKey) {
        this.showDelConfirm = true;
      } else {
        toastr.warn("Please select a row that want to be Delete!");
      }
    },
    deleteData: async function () {
      try {
        this.isLoading = true;
        await apkontrak.remove(this.model);
        // this.data();
        const index = this.tblDataItems.findIndex(
          (r) => r.kontrakKey == this.model.kontrakKey
        );
        this.tblDataItems.splice(index, 1);
        this.isLoading = false;
      } catch (error) {
        if (error.sql) {
          toastr.error(error.sql, "ERROR MESSAGE", 10000);
        } else if (error.sqlMessage) {
          toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
        } else if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },

    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    posting: async function () {
      if (this.model.kontrakKey) {
        if ((this.model.posting || 0) == 0) {
          if (this.model.vendor_id == "")
            toastr.err(
              "ID/Kode Vendor belum diisi, proses tidak bisa dilanjutkan!"
            );
          if (this.model.postgroup == "")
            toastr.err(
              "Kelompok Posting belum diisi, proses tidak bisa dilanjutkan!"
            );
          this.showPostingConfirm = true;
        }
        if (this.model.posting == 1) {
          this.showUnpostConfirm = true;
        }
      } else {
        toastr.warn("Please select a row that want to be Posted!");
      }
    },
    postingData: async function () {
      this.isLoading = true;
      try {
        await apkontrak.posting(this.model);
        this.model.posting = 1;
        this.printjv();
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    unpostData: async function () {
      this.isLoading = true;
      try {
        await apkontrak.postingUndo(this.model);
        this.model.posting = 0;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },

    printjv: async function () {
      if (this.model.kontrakKey) {
        try {
          this.showReport = true;
          this.isprintjv = true;
          this.reportUrl = await apkontrak.printjv(this.model);
          if (this.$isMobile()) {
            this.showReport = false;
            window.location.href = `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
          }
        } catch (error) {
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      } else {
        toastr.warn("Please select a row that want to be Printed!");
      }
    },
    payment: async function () {
      if (this.model.kontrakKey) {
        // const row = { totalsettle: 0, siskontrak: 0 };
        // for (var key in this.model) {
        //   row[key] = this.model[key];
        // }
        // row.tanggal = row.tanggal
        //   ? moment(row.tanggal).format("YYYY-MM-DD")
        //   : "";
        // row.tglSKA = row.tglSKA ? moment(row.tglSKA).format("YYYY-MM-DD") : "";
        // this.paymdata = row;
        const resp = await apkontrak.paymenthistory(this.model);
        console.log("Biil Hist: ", resp);
        this.paymdata = resp.kontrak;
        this.paymdata.tanggal = this.paymdata.tanggal
          ? moment(this.paymdata.tanggal).format("YYYY-MM-DD")
          : "";
        this.paymdata.tglSKA = this.paymdata.tglSKA
          ? moment(this.paymdata.tglSKA).format("YYYY-MM-DD")
          : "";
        this.paymdata.paymLines = resp.apList;

        // let totalsettle = 0;
        // this.paymdata.paymLines.forEach((trx) => {
        //   totalsettle += trx.totalinv || 0;
        // });
        // this.paymdata.totalsettle = totalsettle;
        this.$forceUpdate();
        this.showPaymentForm = true;
        this.data();
      } else {
        toastr.warn("Please select a row that want to be view the Payment!");
      }
    },
    exportxls: async function () {
      this.isLoading = true;
      try {
        const response = await apkontrak.exportxls(this.tblData);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message);
        } else {
          toastr.error(JSON.stringify(error));
        }
      }
    },
    close() {
      router.push("/payable/home");
    },
  },
};
</script>
